import styled from "styled-components";
const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
`;
export default LayoutContainer;
